import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import Contact from "./Contact";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

function Menu({ section1, services, about ,close }) {
    const location = useLocation();
    const navigate = useNavigate();
    const [menuAnimation, menuAnimationInView] = useInView({
      triggerOnce: true, // Animation triggered only once
      threshold: 0.5, // Adjust the threshold as needed
    });
    const animationVariants = {
      hidden: {
        opacity: 0,
      },
      visible: {
        opacity: 1,
        transition: {
          duration: .6,
          ease: "easeInOut",
        },
      },
    };
  return (
    <motion.div className="menu"
    ref={menuAnimation}
    initial="hidden"
    animate={menuAnimationInView ? "visible" : "hidden"}
    variants={animationVariants}
    >
        <AiOutlineClose className="menu-close-btn" size={25} onClick={close} />
      <div className="menu-items">
        <div
          className="menu-item"
          onClick={() => {
            if (location.pathname == "/") {
              section1.current.scrollIntoView({ behavior: "smooth" });
            } else {
              navigate(`/`);
            }
            close()
          }}
        >
          Home
        </div>
        <div
          className="menu-item"
          onClick={() => {
            if (location.pathname == "/") {
              services.current.scrollIntoView({ behavior: "smooth" });
            } else {
              navigate(`/`);
            }
            close()
          }}
        >
          Services
        </div>
        <div
          className="menu-item"
          onClick={() => {
            if (location.pathname == "/") {
              about.current.scrollIntoView({ behavior: "smooth" });
            } else {
              navigate(`/`);
            }
            close()
          }}
        >
          About
        </div>
        <div
          className="menu-item"
          onClick={() => {
            if (location.pathname == "/") {
              navigate(`/projects`);
            }
            close()
          }}
        >
          Projects
        </div>
      </div>
      <Contact/>
    </motion.div>
  );
}

export default Menu;

